import { useAuth, useVerifyPermission } from "@airborne/react-admin";
import * as React from "react";
import { GetServiceableStatus, ServiceableStatu } from "../../../../Enums/ServiceableStatus";
import { GetUnserviceableStatus, UnserviceableStatu } from "../../../../Enums/UnserviceableStatus";
import { ExcelExport } from "../../../../Helper/ExportExcel";
import { DashboardPbhExcelHeader, DashboardPbhExcelName } from "../../ExcelPbh";
import { TitleDashboardPbh } from "../../Source";
import DashboardFilter from "./DashboardFilter";
import PbhDashboardDataGrid from "./DataGrid";
import { connect } from "react-redux";
import ListActions from "./ListActions";
import PoolList from "../../../../Components/PoolListComponent/PoolListComponent";
import { GetAlternatePnStatus } from "../../../../../src/Enums/AlternatePnStatus";

const DashboardPbh = props => {
  const { user } = useAuth();
  useVerifyPermission("customroutes", "dashboardpbh.read");
  const ExportToExcelPbh = data => {
    ExcelExport(
      DashboardPbhExcelHeader,
      data.map(v => [
        v.refNo,
        v.customerName,
        v.customerPo,
        v.requirementCategoryText,
        v.pn,
        v.pnDescription,
        v.isPool,
        v.airportCode,
        v.acRegistration,
        v.createdDate,
        v.requestedDeliveryDate,
        v.requestStatusText,
        v.alternatePnStatus != null ? GetAlternatePnStatus.find(x => x.Value == v.alternatePnStatus)?.Description : "",
        GetServiceableStatus.filter(x => x.Value == (v.serviceable === null ? ServiceableStatu.None : v.serviceable))[0]
          ?.Description ?? "NONE",
        GetUnserviceableStatus.filter(
          x => x.Value == (v.unserviceable === null ? UnserviceableStatu.None : v.unserviceable)
        )[0]?.Description ?? "NONE",
        v.currentPbhNote,
      ]),
      DashboardPbhExcelName,
      user
    );
  };
  return (
    <PoolList
      {...props}
      resource={"pbhrequestorders/dashboardpbh"}
      basePath={"dashboardpbh"}
      perPage={25}
      title={TitleDashboardPbh}
      sort={{ field: "createdDate", order: "DESC" }}
      exporter={ExportToExcelPbh}
      filters={<DashboardFilter />}
      actions={<ListActions {...props} />}
      hasCreate={false}
    >
      <PbhDashboardDataGrid />
    </PoolList>
  );
};

const mapStateToProps = state => ({
  statusList: state.pbhDashboard.statusList,
});
const mapDispatchToProps = dispatch => ({});
export default connect(mapStateToProps, mapDispatchToProps)(DashboardPbh);
